// src/pages/Home.jsx
import React from 'react';
import Header from '../components/Header';
import LinkList from '../components/LinkList';
import Socials from '../components/Socials';

const Home = () => {
  return (
    <div className="app-container">
      <Header />
      <div className='socials'>
        <Socials />
      </div>
      <div className="link-list">
        <LinkList />
      </div>
    </div>
  );
};

export default Home;